// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__dls3+","closebtn":"Banner_closebtn__0TTJk"};